import React from "react";
import Modal from "react-modal";
import { useModal } from "../../context/LoaderContext";
import congrats from "../../assets/gifs/congratulations.gif";
import thumbsUp from "../../assets/gifs/Success-Thumbs-Up-for-Job-Posted-Bid-Posted.gif";
import jobPosted from "../../assets/gifs/job-posted.gif";
import fileAComplain from "../../assets/gifs/file-a-complain.gif";
import card from "../../assets/gifs/card.gif";
import invite from "../../assets/gifs/invite-freelancer.gif";
import bidding from "../../assets/gifs/bidding.gif";
import earningCoins from "../../assets/gifs/earning-coins.gif";
import CourseProgress from "../../assets/gifs/Course-Progress.gif";
import courseComplete from "../../assets/gifs/course-complete.gif";
import jobComplete from "../../assets/gifs/jobCompleted.gif";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    minWidth: "600px",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    textAlign: "center",
    border: "none",
    borderRadius: "1rem",
    boxShadow: "0px 0px 15px 1px #e3e3e3",
    FontFamily: "poppins",
  },
};

const CongratulationsModal = () => {
  const { modal, modalGif, modalHeading, modalSubHeading, closeModal } =
    useModal();

  return (
    <Modal
      isOpen={modal}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Congratulations Modal"
    >
      {modalGif === "congrats" ? (
        <img src={congrats} alt="" width={"400px"} />
      ) : modalGif === "thubsUp" ? (
        <img src={thumbsUp} alt="" />
      ) : modalGif === "jobPosted" ? (
        <img src={jobPosted} alt="" />
      ) : modalGif === "fileAComplain" ? (
        <img src={fileAComplain} alt="" width={"300px"} />
      ) : modalGif === "card" ? (
        <img src={card} alt="" width={"300px"} />
      ) : modalGif === "invite" ? (
        <img src={invite} alt="" width={"300px"} />
      ) : modalGif === "bidding" ? (
        <img src={bidding} alt="" width={"300px"} />
      ) : modalGif === "course-earn" ? (
        <img src={earningCoins} alt="" width={"300px"} />
      ) : modalGif === "course-progress" ? (
        <img src={CourseProgress} alt="" width={"300px"} />
      ) : modalGif === "course-complete" ? (
        <img src={courseComplete} alt="" width={"300px"} />
      ) : modalGif === "completeJob" ? (
        <img src={jobComplete} alt="" width={"300px"} />
      ) : null}
      <div className="mt-4">
        {/* <h2>Congratulations!</h2>
        <p>You are awesome and deserve all the success. Well done!</p> */}
        <h2 style={{ fontWeight: 600 }}>{modalHeading}</h2>
        <p style={{ textAlign: "center", maxWidth: "500px" }}>
          {modalSubHeading}
        </p>
        <button className="btn btn-primary float-right" onClick={closeModal}>
          Close
        </button>
      </div>
    </Modal>
  );
};

export default CongratulationsModal;
